import { GridWrapper } from './styles';
import { AgGridReact, AgGridColumnProps, AgGridColumnGroupProps } from 'ag-grid-react';
import {
    IHeaderParams, GridApi, ColumnApi, GridReadyEvent,
    ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, GridSizeChangedEvent, SortChangedEvent, ViewportChangedEvent
} from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { QuestCategory } from '@nkr/enums/index';
import { IFamilyVoucherScreeningTransactionDetails, IPreWorkUpTransactionDetails, IQuestTransactionRequest } from '@nkr/models/index';
import { useState } from 'react';
import { Utility } from '@nkr/services/utility';

type MyColumn = AgGridColumnProps | AgGridColumnGroupProps;

interface IProps {
    data: {
        preWorkupLabResults: IPreWorkUpTransactionDetails[],
        fvScreeningResults: IFamilyVoucherScreeningTransactionDetails[],
    },
    selectedTab: QuestCategory
}

const QuestReportGrid = (props: IProps) => {
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [preWorkupColumns, setPreWorkupColumns] = useState<MyColumn[]>([
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    R#
                </SortableHeaderComponent>,
            headerName: 'Rank',
            maxWidth: 55,
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'donorCenterAlias',
            field: 'donorCenterAlias',
            headerName: 'Center Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Center Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true,
            suppressSizeToFit: true
        },
        {
            colId: 'donorFirstName',
            field: 'donorFirstName',
            headerName: 'Donor First Name',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor First Name
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            hide: false
        },
        {
            colId: 'donorLastName',
            field: 'donorLastName',
            headerName: 'Donor Last Name',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Last Name
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            hide: false
        },
        {
            colId: 'donorEmail',
            field: 'donorEmail',
            headerName: 'Donor Email',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Email
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            hide: false
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true,
            suppressSizeToFit: true,
            hide: true
        },
        {
            colId: 'fileName',
            field: 'fileName',
            headerName: 'File Name',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    File Name
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'requestedDate',
            field: 'requestedDate',
            headerName: 'Requested Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Requested Date
                </SortableHeaderComponent>,
            minWidth: 90,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            comparator: Utility.dateComparator
        },
        {
            colId: 'completedDate',
            field: 'completedDate',
            headerName: 'Completed Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Completed Date
                </SortableHeaderComponent>,
            minWidth: 90,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            comparator: Utility.dateComparator
        }
    ]);
    const [familyVoucherColumns, setFamilyVoucherColumns] = useState<MyColumn[]>([
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    R#
                </SortableHeaderComponent>,
            headerName: 'Rank',
            maxWidth: 55,
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'donorCenterAlias',
            field: 'donorCenterAlias',
            headerName: 'Center Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Center Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true,
            suppressSizeToFit: true
        },

        {
            colId: 'donorFirstName',
            field: 'donorFirstName',
            headerName: 'Donor First Name',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor First Name
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            hide: true
        },
        {
            colId: 'donorLastName',
            field: 'donorLastName',
            headerName: 'Donor Last Name',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Last Name
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            hide: true
        },
        {
            colId: 'donorEmail',
            field: 'donorEmail',
            headerName: 'Donor Email',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Email
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true,
            hide: true
        },

        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Alias
                </SortableHeaderComponent>,
            width: 120,
            sortable: true,
            resizable: true,
            suppressSizeToFit: true,
            hide: false
        },
        {
            colId: 'fileName',
            field: 'fileName',
            headerName: 'File Name',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    File Name
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'requestedDate',
            field: 'requestedDate',
            headerName: 'Requested Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Requested Date
                </SortableHeaderComponent>,
            minWidth: 90,
            sortable: true,
            resizable: true,
            comparator: Utility.dateComparator
        },
        {
            colId: 'completedDate',
            field: 'completedDate',
            headerName: 'Completed Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Completed Date
                </SortableHeaderComponent>,
            minWidth: 90,
            sortable: true,
            resizable: true,
            comparator: Utility.dateComparator
        }
    ]);

    const onGridReady = (e: GridReadyEvent) => {
        setGridApi(e.api);
        setColumnApi(e.columnApi);
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        // get the current grids width
        let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

        // keep track of which columns to hide/show
        let columnsToShow = [];
        let columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        let totalColsWidth = 0;
        let allColumns = e.columnApi.getAllColumns();

        for (let i = 0; i < allColumns.length; i++) {
            let column = allColumns[i];
            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        e.columnApi.setColumnsVisible(columnsToShow, true);
        e.columnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        gridApi.sizeColumnsToFit();
    };

    const onViewportChanged = (e: ViewportChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    if (props.data == null)
        return null;

    if (props.selectedTab == QuestCategory.PreWorkUp) {
        return (
            <div className='row'>
                <div className='col-sm-12'>
                    <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
                        <AgGridReact
                            rowData={props.data.preWorkupLabResults}
                            columnDefs={preWorkupColumns}
                            enableCellTextSelection={true}
                            enableRangeSelection={true}
                            noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                            suppressCellSelection={true}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            onViewportChanged={onViewportChanged}
                            onSortChanged={onSortChanged}
                        />
                    </GridWrapper>
                </div>
            </div>
        );
    }

    if (props.selectedTab == QuestCategory.FamilyVoucherScreening) {
        return (
            <div className='row'>
                <div className='col-sm-12'>
                    <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
                        <AgGridReact
                            rowData={props.data.fvScreeningResults}
                            columnDefs={familyVoucherColumns}
                            enableCellTextSelection={true}
                            enableRangeSelection={true}
                            noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                            suppressCellSelection={true}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            onViewportChanged={onViewportChanged}
                            onSortChanged={onSortChanged}
                        />
                    </GridWrapper>
                </div>
            </div>
        )

        return null;
    }
}

export default QuestReportGrid;